import { Controller } from 'stimulus';

/**
 *  Show shipping address form
 *
 * @class Address
 * @extends {Controller}
 */
class Address extends Controller {
  connect() {
    this.toggleShippingAddressFields();
  }

  toggleShippingAddressFields() {
    const isChecked = this.shippingAddressTogglerTarget.checked;

    $(this.shippingAddressFieldsTarget).toggle(isChecked);
    $(this.shippingAddressFieldsTarget).find('[data-required]').prop('required', isChecked);
  }
}

Address.targets = [
  'shippingAddressToggler',
  'shippingAddressFields',
];

export default Address;
